var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-risk-analysis',{attrs:{"the-client":_vm.client}})
}
var staticRenderFns = []

export { render, staticRenderFns }